// extracted by mini-css-extract-plugin
export default {"col":"styles_col__LRETs","formContainer":"styles_formContainer__ijFdG","form":"styles_form__q5iE8"};